export const commonPopup = {
  title: '',
  content: '',
  ok: '確定',
  cancel: '取消',
};
